import _ from 'lodash';
import { Record } from 'immutable';
import PhotoHash from './PhotoHash';
import Review from './Review';

const WineProfileDefaults = {
  id: null,
  name: null,
  producer: null,
  description: null,
  photo_hash: null,
  attributes: [],
  rating: null,
  reviews: []
};

class WineProfile extends Record(WineProfileDefaults) {
  constructor(values) {
    values.photo_hash = (values.photo_hash instanceof PhotoHash) ? values.photo_hash : new PhotoHash(values.photo_hash);
    values.reviews = values.reviews.filter((review) => {return !!review;});
    values.reviews = _.map((values.reviews || []), (reviewSet) => {
      let objects = [];
      reviewSet.objects = _.each(reviewSet.objects, (review) => {
        if(review.review) {
          // NOTE: Filtering out reviews without text
          objects.push(review instanceof Review ? review : new Review(review));
        }
      });
      return {
        type: reviewSet.type,
        header: reviewSet.header,
        objects: objects
      };
    });

    super(values);
  }
}

export default WineProfile;



// WEBPACK FOOTER //
// banquet/models/WineProfile.js